module.exports = "/_next/static/images/complaint-mediation-c44a2c93d13fcdb05f4ef25cfc0c1ae2.png";